import { DeactivationReasonEnum } from '../../lib/types/enums/staff/deactivation-reason.enum'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

interface DeactivateHostFamiliesInput extends IdsInput {
  deactivationReason: DeactivationReasonEnum
}

export const deactivateHostFamilies = (data: DeactivateHostFamiliesInput) => {
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.deactivate.url, null))
    .patch<never, DeactivateHostFamiliesInput>(data)
}
